import React from "react";
import { useTranslation } from "react-i18next";
import { Archive, CheckCircle2, FilePen, PenLine, Sparkles } from "lucide-react";

export type OSNormativStatus = "new" | "draft" | "prepared" | "approved" | "archived";

/**
 * Status pill in the normativ title bar (Нов / Нацрт / Подготвен / Одобрен / Архивиран).
 * Display only — the status is derived by the screen from the signatures / archive view.
 */

const STATUS_STYLES: Record<OSNormativStatus, { cls: string; Icon: React.ElementType }> = {
  new: { cls: "bg-blue-50 text-blue-700 ring-blue-200", Icon: Sparkles },
  draft: { cls: "bg-gray-50 text-gray-600 ring-gray-200", Icon: FilePen },
  prepared: { cls: "bg-blue-50 text-blue-700 ring-blue-200", Icon: PenLine },
  approved: { cls: "bg-green-50 text-green-700 ring-green-200", Icon: CheckCircle2 },
  archived: { cls: "bg-gray-100 text-gray-600 ring-gray-300", Icon: Archive },
};

const OSNormativStatusBadge: React.FC<{ status: OSNormativStatus }> = ({ status }) => {
  const { t } = useTranslation();
  const { cls, Icon } = STATUS_STYLES[status];
  const label = t(`os.normativStatus.${status}`);

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 whitespace-nowrap ${cls}`}
      title={`${t("os.normativStatus.label")}: ${label}`}
    >
      <Icon size={14} />
      {label}
    </span>
  );
};

export default OSNormativStatusBadge;
